import { Select } from "@material-ui/core";
import { call, put, takeEvery } from "redux-saga/effects";
import { callApi, callApiWithNoAuth, Method } from "../../api/Api";
import { getHomeState } from "../home/selector";
import { stopLoading, showErrorMessage, startLoading } from "../layout/action";
import {
  GET_ADDPERMIT_TEXT,
  GET_ADDPERMIT_WITHOUTSESSION_TEXT,
  setAddPermitText,
  setAddPermitWithoutSession,
} from "./action";

export function* watchGetAddpermitwithoutText() {
  yield takeEvery(GET_ADDPERMIT_WITHOUTSESSION_TEXT, function* ({ payload }) {
    try {
      yield put(startLoading());
      const response = yield call(callApiWithNoAuth, {
        // url: `/portal/pages/create-login/${payload}`,
        url: `/portal/pages/home-without-session/create-login/${payload}`,
        method: Method.GET,
      });
      yield put(
        setAddPermitWithoutSession(response.data[0].text || { text: "" })
      );
      yield put(stopLoading());
    } catch (err) {
      yield put(stopLoading());
      yield put(showErrorMessage({ error: err, title: "Get Add Permit Text" }));
    }
  });
}
export function* watchGetAddPermitText() {
  yield takeEvery(GET_ADDPERMIT_TEXT, function* ({ payload }) {
    try {
      const { customerName } = yield Select(getHomeState);

      const response = yield call(callApi, {
        url: `/portal/pages/permit-selection/${customerName}`,
        method: Method.GET,
      });
      yield put(setAddPermitText(response.data[0] || { text: "" }));
    } catch (err) {
      yield put(stopLoading());
      yield put(showErrorMessage({ error: err, title: "Get Add Permit Text" }));
    }
  });
}
